export default [
	{ id: 'manual', label: 'scorecards.node.metric.updateType.manual', icon: 'manual' },
	{ id: 'calculated', label: 'scorecards.node.metric.updateType.calculated', icon: 'calculated' }
];
